import React, { useMemo } from 'react'
import { ReadOnlyField } from 'src/component/profile/personal-info/read-only-field'
import { OutlinedButton } from 'src/component/ui/button'
import { useSessionContext } from 'src/context/session-context'
import { Gender, HeightUnit, WeightUnit } from 'src/dao/core-dao'
import { timeUtil } from 'src/util/time-util'

interface ReadPersonalDetailsProps {
  onEdit: () => void
}

const formatGender = (gender?: Gender | null): string => {
  if (!gender) return '—'
  switch (gender) {
    case Gender.MALE:
      return 'Male'
    case Gender.FEMALE:
      return 'Female'
    case Gender.NON_BINARY:
      return 'Non-binary'
    case Gender.N_A:
      return 'Prefer not to say'
    default:
      return '—'
  }
}

const formatDate = (dateString?: Date | null): string => {
  if (!dateString) return '—'
  return timeUtil.stringToDateFormat(new Date(dateString).toISOString())
}

const formatHeight = (height?: { value: number; unit: HeightUnit } | null): string => {
  if (!height) return '—'
  return `${height.value} ${height.unit}`
}

const formatWeight = (weight?: { value: number; unit: WeightUnit } | null): string => {
  if (!weight) return '—'
  return `${weight.value} ${weight.unit}`
}

export const ReadPersonalDetails = ({ onEdit }: ReadPersonalDetailsProps): React.ReactElement => {
  const { me } = useSessionContext()

  const isLoading = useMemo(() => !me, [me])

  return (
    <div data-nextstep="personal-details">
      <div className="flex items-center justify-between !mb-5">
        <h6 className="font-evogria text-sm md:text-base text-ivory uppercase">Personal Details</h6>
        <OutlinedButton size="sm" className="border-ivory text-ivory px-4" onClick={onEdit}>
          Edit
        </OutlinedButton>
      </div>
      <div className="space-y-3">
        <ReadOnlyField label="Username" value={me?.profile?.username || '—'} isLoading={isLoading} />
        <ReadOnlyField label="Gender" value={formatGender(me?.profile?.gender)} isLoading={isLoading} />
        <ReadOnlyField label="Date of birth" value={formatDate(me?.profile?.dateOfBirth)} isLoading={isLoading} />
        <ReadOnlyField label="Height" value={formatHeight(me?.profile?.height)} isLoading={isLoading} />
        <ReadOnlyField label="Weight" value={formatWeight(me?.profile?.weight)} isLoading={isLoading} />
      </div>
    </div>
  )
}
